module.exports = __webpack_public_path__ + "img/it.a115cfa8.svg";